<template>
    <el-row gutter="15" style="margin-bottom: 1vh;margin-top: 20px;">
        <el-col :span="12">
            <a  target="_blank">
                <div class="custom-card">
                    <img src="http://47.121.206.97:8000/upload/images/cd32106bcb6de321930cf34574ea388c_1723215473924991581.png" alt="智慧交通" class="card-image">
                    
                </div>
            </a>
        </el-col>
        <el-col :span="12">
            <a target="_blank">
                <div class="custom-card">
                    <img src="http://47.121.206.97:8000/upload/images/ef8a9f751393cecaf3e811c30ee3e756_1723215495484402399.png" alt="虚拟现实" class="card-image">
                </div>
            </a>
        </el-col>
    </el-row>
    <el-row gutter="15">
        <el-col :span="12">
            <a  target="_blank">
                <div class="custom-card">
                    
                    <img src="http://47.121.206.97:8000/upload/images/26748b021bdc8922f93d9bf054cbec5d_1723215516124605038.png" alt="无线通信" class="card-image">
                
                </div>
            </a>
        </el-col>
        <el-col :span="12">
            <a  target="_blank">
                <div class="custom-card">
                    <img src="http://47.121.206.97:8000/upload/images/bcb24d33d2a22de9b0c3e9f38becc496_1723215435165351068.png" alt="人机交互" class="card-image">
                </div>
            </a>
        </el-col>
    </el-row>
    <el-row style="margin-top: 35px;">
        <div style="display: flex; align-items: baseline;">
            <h1 lang="en" style="margin-right: 8px;">UIS</h1>
            <h1>实验室</h1>
        </div>
    </el-row>
    <el-row style="margin-top: 0;">
        <div class="text-container">
            <p>人机交互硏究交互式计算系统的设计、实现与评估，旨在提升人与计算系统之间的信息交换能力。人机交互技术变革不断突破用户使用计算机的难度瓶颈，使得计算得以从少量专家用户的科学计算扩展到数十亿人的日常应用，在国家科技战略、信息技术创新、社会经济发展中扮演着越来越重要的角色，受到学术界和产业界的高度重视。</p>
            <p>我们感兴趣的研究领域包括下列主题：</p>
            <ul>
                <li>虚拟/增强现实交互</li>
                <li>人机交互设计与界面评估</li>
                <li>无人机无线网络通信</li>
            </ul>
        </div>
    </el-row>


</template>

<style scoped>
.custom-card {
    width: 100%;
    height: 38vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
}

.card-image {
    width: 100%;
    height: 100%;
}

.card-title {
    font-size: 18px;
    color: #333;
    padding: 5px;
}

.text-container {
    font-size: 18px;
    line-height: 1.5;
}

h1 {
    margin-top: 0;    /* 减少上边距 */
    margin-bottom: 0; /* 减少下边距 */
}
</style>
